import gql from 'graphql-tag'

export default gql`
query getTares {
	cashAssist {
		getAppConfig {
			taraName
		}
	}
}
`
